import { APP_NAME, metafieldFields } from "../fields";

export const isOfflineMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "isoffline")',
    alias: "isOffline",
  },
  fields: metafieldFields,
  variables: {},
};

export const instagramMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "instagram")',
    alias: "instagram",
  },
  fields: metafieldFields,
  variables: {},
};

export const drawStatusMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "draw_status")',
    alias: "drawStatus",
  },
  fields: metafieldFields,
  variables: {},
};

const returnStatusName: Record<string, string> = {
  tune: '(namespace: "custom", key: "return_status")',
  yeseyesee: '(namespace: "return", key: "status")',
  thisisneverthat: '(namespace: "return", key: "status")',
  khakis: '(namespace: "return", key: "status")',
  jknd: '(namespace: "return", key: "status")',
};

export const returnStatusMetafield = {
  operation: {
    name: `metafield${returnStatusName[APP_NAME]}`,
    alias: "returnStatus",
  },
  fields: metafieldFields,
  variables: {},
};

export const returnImagesMetafield = {
  operation: {
    name: 'metafield(namespace: "return", key: "images")',
    alias: "returnImages",
  },
  fields: metafieldFields,
  variables: {},
};

export const featuredImageMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "featured_image")',
    alias: "featuredImage",
  },
  fields: metafieldFields,
  variables: {},
};

export const isFamilySaleMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "isfamilysale")',
    alias: "isfamilysale",
  },
  fields: metafieldFields,
  variables: {},
};
